export const SET_TENANTS = "SET_TENANTS";
export const RESET_TENANTS = "RESET_TENANTS";
export const SET_SPECIFIC_TENANTS = "SET_SPECIFIC_TENANTS";
export const RESET_SPECIFIC_TENANTS = "RESET_SPECIFIC_TENANTS";
export const SET_TENANT_ROLES = "SET_TENANT_ROLES";
export const RESET_TENANT_ROLES = "RESET_TENANT_ROLES";
